import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "footer px-4 mx-2" }
const _hoisted_2 = { class: "row align-items-center justify-content-lg-between" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "copyright text-center text-lg-left text-muted" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://dada-dada.com/",
  class: "font-weight-bold ml-1",
  target: "_blank"
}, " Dada Dada & Cia ", -1)
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "nav nav-footer justify-content-center justify-content-lg-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    target: "_blank"
  }, " Call Center ")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  target: "_blank"
}, " Omnichannel ", -1)
const _hoisted_11 = [
  _hoisted_10
]

import { env } from "@/config";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const year = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" © " + _toDisplayString(_unref(year)) + " ", 1),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _hoisted_8,
          (!_unref(env).onlyCallcenter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})